<template>
  <div v-bind:class="{ btn: true, disabled: disabled }" v-on:click="submit">
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    label: String
  },
  methods: {
    submit() {
      if (!this.disabled) {
        this.$emit("click");
      }
    }
  }
};
</script>
<style>
.btn {
  background-color: orange;
  width: 300px;
  text-align: center;
  margin: 20px auto;
  height: 60px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  font-size: 22px;
  align-items: center;
}
.btn.disabled {
  opacity: 0.4;
}
</style>
